// @flow

export const DEFAULT_MAX_LENGTH = 80;
export const DEFAULT_SUFFIX = '…';

type Options = {
  maxLength?: number,
  suffix?: string,
};

export default function truncateUrl(url: string, options?: Options = {}): string {
  const { maxLength = DEFAULT_MAX_LENGTH, suffix = DEFAULT_SUFFIX } = options;

  if (url.length <= maxLength) {
    return url;
  }

  const rawTruncatedUrl = url.substring(0, maxLength - 1);
  // strip all trailing punctuation and spaces before applying the suffix
  const strippedTruncatedUrl = rawTruncatedUrl.replace(/[\- _,.<>:;+=*&@~\/\|!]*$/, '');
  return strippedTruncatedUrl + suffix;
}
